import 'core-js/es6/array';
import 'core-js/es6/object';
import 'core-js/es6/string';
// Global options
import defaults from './_config';
// general helper functions
import Helper from './_helpers';
// general pricing and currency functions
import Pricing from './_pricing';
// throttle and debounce manager
import Throttler from './throttler';

class rcWidget {
    constructor() {
        this.tooltip = null;
        this.options = {};
        this.products = [];
        this.forms = [];
        this.throttler = new Throttler();

        if (arguments[0] && typeof(arguments[0]) === 'object') {
            Object.assign(this.options, defaults);
            Object.assign(this.options, arguments[0]);
            //this.options = { ...defaults, ...arguments[0]};
        } else {
            Object.assign(this.options, defaults);
            //this.options = { ...defaults};
        }
    }

    addProduct(product) {
        let self = this;

        // Don't include duplicate products, search by product.id
        if (self.products.some(x => x.id === product.id)) {
            return;
        }

        // create new copy of rcWidget options then override it with product specific options
        product = Object.assign(
            Object.assign({}, self.options), 
            product);

        self.products.push(product);

        clearTimeout(self.runTimer);

        self.runTimer = setTimeout(() => {
            self.run();
            self.checkTestMode();
        }, this.options.delay);
    }

    checkTestMode() {
        if (!Helper.getUrlParameter('recharge')) {
            return
        }

        alert('ReCharge preview mode.');

        console.info(self);

        Array.from(document.querySelectorAll('#rc_container'),
            elem => elem.style.display = 'block');
    }

    run() {
        let self = this;

        self.products.forEach(product => {
            product.forms = rcWidget._checkAndGetProductForms(product);
            product.elements = [];

            product.forms.forEach((form, i) => {
                product.elements.push(rcWidget._getFormElements(form, product));
                product.elements[i].variantInputs = rcWidget._getVariantInputs(form, product);
                product.elements[i].productPrice = Pricing.getPriceElements(document, product.price_selector);
                if (!product.subscription_only) {
                    rcWidget._renameElements(form);
                }
            });

            if (product.elements[0]) {
                self.addListeners(product);

                rcWidget._updateDuplicateSelector(product);
                rcWidget._updateActiveSelect(product);
                rcWidget._updatePricing(product);
            }
        })

        self.helpers();
    }

    addListeners(product) {
        rcWidget._addPurchaseTypeListeners(product);
        rcWidget._addIntervalOptionListeners(product);
        rcWidget._addVariantInputListeners(this.throttler, product);
        rcWidget._addPricingListeners(product);
    }

    helpers() {
        rcWidget._identifyTheme();
        rcWidget._disableAjaxCart(this.products);
        rcWidget._showAddToCartButton();


        if (window.ReCharge.products.length > 1) {
            console.info('Multiple products. This feature is not fully supported', window.ReCharge.products);
        }

        if (!window.ReCharge.products[0].forms.length) {
            console.warn('Product form not found', window.ReCharge.products[0]);
        }

        if (!window.ReCharge.products[0].elements[0].productPrice) {
            console.warn('Product price not found. If missing, pass the price_selector parameter', window.ReCharge.products[0].price_selector);
        }

        window.addEventListener('pageshow', event => {
            if (event.persisted || window.performance && window.performance.navigation.type === 2) {
                window.location.reload();
            }
        }, false);
    }

    static _identifyTheme() {
        if (window.Shopify) {
            let shopifyTheme = window.Shopify.theme.name,
                themeList = [
                    // Original
                    'Alchemy', 'Atlantic', 'Blockshop', 'Brooklyn',
                    'California', 'Classic', 'Clean', 'Envy', 'Fluid', 'Focal',
                    'Kickstand', 'Launchpad', 'Limitless', 'Minimal', 'Mobilia', 'New Standard', 
                    'Pacific', 'Palo Alto', 'Parallax', 'Pop', 'Radiance', 'React', 'Responsive', 'Retina',
                    'Solo', 'Startup', 'Supply', 'Vantage', 'Vintage',
                    // Widget v3
                    'Boundless', 'Debut', 'District', 'Fashionopolism', 'Grid', 'Icon', 'Jumpstart',
                    'Lookbook', 'Pipeline', 'Providence', 'Simple', 'Symmetry', 'Testament', 'Venture', 'Wonderskin',
                    // Widget v3+
                    'Cookbook', 'Expression', 'Flex', 'Jitensha', 'Masonry', 'Mr Parker', 'Showtime',
                    'Vanity', 'Palo Alto', 'Vintage', 'Weekend', 'Ms Parker', 'Trademark', 'Kingdom', 'Showcase',
                    'Handy', 'Kagami', 'Avenues', 'Turbo', 'Slate'
                ];
            // Search through themeList for (similair) matching theme name
            let knownTheme = themeList.find(theme => shopifyTheme.toLowerCase().indexOf(theme.toLowerCase()) > -1);
            // Set identified theme as found theme name or return shopifyTheme name.
            shopifyTheme = (knownTheme || shopifyTheme).toLowerCase();
            if (shopifyTheme === 'turbo') {
                console.info('Turbo theme detected. If ReCharge widget fails to load, set Page Transitions to "Sport"');
            }
            if (shopifyTheme === 'weekend') {
                console.info('Weekened theme detected. "properties[shipping_interval_frequency]", "properties[subscription_id]", "properties[shipping_interval_unit_type]" might be missing from data varaible used in addItem()');
            }
            document.body.className += ` rc_theme--${shopifyTheme.replace(/[\W_]/g, '-')}`;
        }
    }

    static _disableAjaxCart(products) {
        let disableAjax = products.some(prod => prod.disable_ajax);

        if (disableAjax && ShopifyAPI && ShopifyAPI.addItemFromForm) {
            ShopifyAPI.addItemFromForm = form => { form.submit(); }
        }
    }

    static _showAddToCartButton() {
        let buttons = document.querySelectorAll('form[action^="/cart/add"] [type="submit"]');

        Array.from(buttons)
            .forEach(elem => {
                elem.style.visibility = 'visible';
            });
    }

    static _checkAndGetProductForms(product) {
        try {
            return rcWidget
                ._getProductForms(product)
                .filter(elem => elem.querySelector('#rc_subscription_id'));
        } catch (err) {
            console.error(`Product (${product.id}) has no product forms.`, err);
            return [];
        }
    }

    static _getProductForms(product) {
        let query = product.form_selector || `form[data-productid="${product.id}"], form[data-product-id="${product.id}"]`;

        return Array.from(document.querySelectorAll(query));
    }

    static _renameElements(form) {
        Helper.renameForIdPair(form, 'rc_purchase_type_onetime');
        Helper.renameForIdPair(form, 'rc_purchase_type_autodeliver');
        Helper.renameForIdPair(form, 'rc_shipping_interval_frequency');
    }

    static _getFormElements(form, product) {
        let elements = {
            // Purchase types
            'rcContainer': form.querySelector('#rc_container'),
            'purchaseTypes': form.querySelectorAll('[name="purchase_type"]'),
            'radioOnetime': form.querySelector('#rc_purchase_type_onetime'),
            'radioAutodeliver': form.querySelector('#rc_purchase_type_autodeliver'),
            // Subscription options
            'subscriptionID': form.querySelector('#rc_subscription_id'),
            'subscriptionIntervalType': form.querySelector('#rc_shipping_interval_unit_type'),
            'shippingIntervalFrequency': form.querySelector('#rc_shipping_interval_frequency'),
            // Variant selectors
            'productVariantSelector': form.querySelector('[name="id"]'),
            'duplicateVariantSelector': form.querySelector('#rc_duplicate_selector'),
            'selectedPurchaseType': (product.subscription_only || product.select_subscription_first) ? 'autodeliver' : 'onetime',
            // Quantity
            'productQuantity': form.querySelector('[name="quantity"]'),
            // HTML elements
            'onetimePrice': form.querySelector('#rc_price_onetime'),
            'autodeliverPrice': form.querySelector('#rc_price_autodeliver'),
            'intervalOptions': form.querySelector('#rc_autodeliver_options'),
        }

        // Variant selector
        elements['selectedProductSelect'] = (product.subscription_only || product.select_subscription_first) ? elements.duplicateVariantSelector : elements.productVariantSelector;

        Object.keys(elements)
            .filter(k => !elements[k])
            .forEach(k => console.info(`[${product.id}] Missing product element: ${k}`, elements[k]));
        
        return elements;
    }

    static _getVariantInputs(form, product) {
        let query = product.options_selector || 'select, input, textarea, button, a, span, div';

        return Array.from(form.querySelectorAll(query))
            .filter(input => !Helper.findAncestor(input, 'rc_popup'));
    }

    static _addPurchaseTypeListeners(product) {
        let purchaseTypes = Array.from(product.elements[0].purchaseTypes);

        purchaseTypes
            .forEach(elem => {
                elem.addEventListener('click', ev => {
                    let checkedInput = rcWidget._getCheckedInput(purchaseTypes);

                    rcWidget._updatePurchaseType(product, checkedInput.value);
                    rcWidget._updateActiveSelect(product);
                    rcWidget._updatePricing(product);
                });
            });
    }

    static _getCheckedInput(inputs) {
        return inputs.find(elem => elem.checked);
    }

    static _updatePurchaseType(product, type) {
        product.elements[0].selectedPurchaseType = type;
    }

    static _updateDuplicateSelector(product) {
        let productId = product.elements[0].productVariantSelector.value,
            duplicateId = product.variant_to_duplicate[productId];

        product.elements[0].duplicateVariantSelector.value = duplicateId;
    }

    static _updateActiveSelect(product) {
        if (product.elements[0].selectedPurchaseType === 'autodeliver') {
            rcWidget._chooseDuplicateHiddenSelect(product);
        } else {
            rcWidget._chooseOriginalHiddenSelect(product);
        }

        if (!product.subscription_only) {
            rcWidget._highlightSelectedPurchaseType(product);
        }
    }


    static _chooseDuplicateHiddenSelect(product) {
        product.elements[0].productVariantSelector.setAttribute('name', '');
        product.elements[0].duplicateVariantSelector.setAttribute('name', 'id');
        product.elements[0].shippingIntervalFrequency.setAttribute('name', 'properties[shipping_interval_frequency]');
        product.elements[0].subscriptionID.setAttribute('name', 'properties[subscription_id]');
        product.elements[0].subscriptionIntervalType.setAttribute('name', 'properties[shipping_interval_unit_type]');
        product.elements[0].selectedProductSelect = product.elements[0].duplicateVariantSelector;
    }

    static _chooseOriginalHiddenSelect(product) {
        product.elements[0].productVariantSelector.setAttribute('name', 'id');
        product.elements[0].duplicateVariantSelector.setAttribute('name', '');
        product.elements[0].shippingIntervalFrequency.setAttribute('name', '');
        product.elements[0].subscriptionID.setAttribute('name', '');
        product.elements[0].subscriptionIntervalType.setAttribute('name', '');
        product.elements[0].selectedProductSelect = product.elements[0].productVariantSelector;
    }

    static _highlightSelectedPurchaseType(product) {
        if (product.elements[0].radioAutodeliver && product.elements[0].radioOnetime) {
            let autodeliver = Helper.findAncestor(product.elements[0].radioAutodeliver, 'rc_block__type'),
                onetime = Helper.findAncestor(product.elements[0].radioOnetime, 'rc_block__type');

            autodeliver.className = autodeliver.className.replace(' rc_block__type--active', '');
            onetime.className = onetime.className.replace(' rc_block__type--active', '');

            if (product.elements[0].selectedPurchaseType === 'autodeliver') {
                autodeliver.className += ' rc_block__type--active';
            } else {
                onetime.className += ' rc_block__type--active';
            }
        }
    }

    static _updatePricing(product) {
        rcWidget._updateOnetimePrice(product);
        rcWidget._updateAutodeliverPrice(product);
        if (product.update_pricing && !product.subscription_only) {
            rcWidget._updateProductPrice(product);
        }
    }

    static _updateOnetimePrice(product) {
        if (product.elements[0].onetimePrice) {
            let id = product.elements[0].productVariantSelector.value,
                price = product.variant_to_price[id];

            if (!price) {
                console.warn(`[${product.id}] Possible issue with product.variant_to_price[${id}] map. Check _updateOnetimePrice()`, price);
            }
            price = Pricing.calculatePrice(price);
            product.elements[0].onetimePrice.innerHTML = Pricing.buildFormattedPrice(product, price);
        }
    }

    static _updateAutodeliverPrice(product) {
        if (product.elements[0].autodeliverPrice) {
            let id = product.elements[0].duplicateVariantSelector.value,
                price = product.duplicate_to_price[id];
            if (!price) {
                console.warn(`[${product.id}] Possible issue with product.duplicate_to_price[${id}] map. Check _updateAutodeliverPrice()`, price);
            }
            price = Pricing.calculatePrice(price);
            product.elements[0].autodeliverPrice.innerHTML = Pricing.buildFormattedPrice(product, price);
        }
    }

    static _updateProductPrice(product) {
        let price = Pricing.getSelectedPrice(product),
            formattedPrice = Pricing.buildFormattedPrice(product, price),
            priceElements = product.price_selector ? product.elements[0].productPrice : rcWidget._bottomUpPriceSearch(product);


        if (priceElements > product.price_limiter) {
            console.warn(`[${product.id}] Price update disabled. Too many price selectors found (${product.elements[0].productPrice.length} exceeds ${product.price_limiter})`, product.elements[0].productPrice);
            return;
        }

        if (priceElements.length == 0) {
            console.warn(`[${product.id}] Price update disabled. No price selectors found under ${product.price_selector ? 'priceSelector: ' + product.price_selector : product.price_limiter + ' levels from the widget'}`);
            return;
        }

        priceElements.forEach(elem => {
            elem.innerHTML = formattedPrice;
        });
    }

    static _bottomUpPriceSearch(product) {
        let currDomRoot = product.elements[0].rcContainer.parentElement,
            priceElements = [],
            idx = -1;

        while (idx++ < product.dom_step_limiter) {
            priceElements = Pricing.getPriceElements(currDomRoot);
            if (priceElements.length > 0) {
                break;
            } else {
                currDomRoot = currDomRoot.parentElement;
            }
        }

        return priceElements;
    }

    static _addIntervalOptionListeners(product) {
        if (product.elements[0].intervalOptions) {
            product.elements[0].intervalOptions.addEventListener('click', () => {
                product.elements[0].radioAutodeliver.click();
            });
        }
    }

    static _addVariantInputListeners(throttler, product) {
        product.elements[0].variantInputs
            .forEach(elem => {
                let listenerAction = Helper.getListenerAction(elem);

                elem.addEventListener(listenerAction, ev => {
                    //console.log('VARIANT PHASE1 TRIGGERED', ev.target);
                    throttler.throttleAndDebounce(ev, ev => {
                        //console.log('VARIANT PHASE2 TRIGGERED', ev.target);
                        rcWidget._updateDuplicateSelector(product);
                        rcWidget._updatePricing(product);
                    }, product.delay_listener);
                })
            });
    }

    static _addPricingListeners(product) {
        Pricing.addCurrencyListener(elem => {
            let currencyConvertObj = window.Currency ? window.Currency : window.DoublyGlobalCurrency;
            currencyConvertObj.currentCurrency = elem.target.value;
            rcWidget._updatePricing(product);
        });
    }

}

export default rcWidget;



// WEBPACK FOOTER //
// ./_static/js/widget.js